import { CiStar } from "react-icons/ci";
import { RxActivityLog } from "react-icons/rx";
import { Link } from "react-router-dom";

const KegiatandanPrestasi = () => {
  return (
    <div className="w-full flex justify-center mt-12 px-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full max-w-3xl">
        {/* Kegiatan */}
        <Link
          to="/kegiatan"
          className="
            group
            flex flex-col items-center justify-center
            h-40
            rounded-2xl
            bg-gradient-to-br from-blue-100 to-blue-200
            dark:from-blue-900 dark:to-blue-800
            shadow-md
            hover:shadow-xl
            transition-all duration-300
            hover:-translate-y-1
          "
        >
          <div
            className="
            bg-white dark:bg-blue-950
            p-4 rounded-full
            shadow
            mb-3
            group-hover:scale-110
            transition-transform duration-300
          "
          >
            <RxActivityLog
              size={36}
              className="text-blue-600 dark:text-blue-300"
            />
          </div>
          <span className="text-lg font-bold text-gray-800 dark:text-white">
            Kegiatan
          </span>
          <span className="text-sm text-gray-600 dark:text-gray-300">
            Aktivitas Sekolah
          </span>
        </Link>

        {/* Prestasi */}
        <Link
          to="/prestasi"
          className="
            group
            flex flex-col items-center justify-center
            h-40
            rounded-2xl
            bg-gradient-to-br from-yellow-100 to-yellow-200
            dark:from-yellow-900 dark:to-yellow-800
            shadow-md
            hover:shadow-xl
            transition-all duration-300
            hover:-translate-y-1
          "
        >
          <div
            className="
            bg-white dark:bg-yellow-950
            p-4 rounded-full
            shadow
            mb-3
            group-hover:scale-110
            transition-transform duration-300
          "
          >
            <CiStar
              size={36}
              className="text-yellow-500 dark:text-yellow-300"
            />
          </div>
          <span className="text-lg font-bold text-gray-800 dark:text-white">
            Prestasi
          </span>
          <span className="text-sm text-gray-600 dark:text-gray-300">
            Pencapaian Siswa
          </span>
        </Link>
      </div>
    </div>
  );
};

export default KegiatandanPrestasi;
